import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ParentGenericService} from './parent-generic.service';
import {ModelService} from '@cdk/services/model.service';
import {ChatMensagem} from "../models";

@Injectable()
export class ChatMensagemService extends ParentGenericService<ChatMensagem> {
    protected modelService: ModelService;
    protected http = inject(HttpClient);




    constructor() {
        const modelService = inject(ModelService);

        super(modelService, 'administrativo/chat_mensagem', ChatMensagem);

        this.modelService = modelService;
    }

}
